
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/errors/income",
      function () {
        return require("private-next-pages/docs/errors/income.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/errors/income"])
      });
    }
  